import { render, staticRenderFns } from "./searchbar-component.vue?vue&type=template&id=3043483a"
import script from "./searchbar-component.vue?vue&type=script&lang=js"
export * from "./searchbar-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports